/**
 * PublicNav.tsx
 * Sticky navigation bar shared across all public-facing pages (About, Terms, Privacy).
 * Uses ab- CSS classes defined in AboutPage.css.
 */

import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { checkAuthStatus } from '../../api/user';

export function PublicNav() {
  const [isAuthed, setIsAuthed] = useState<boolean | null>(null);

  useEffect(() => {
    checkAuthStatus().then(setIsAuthed).catch(() => setIsAuthed(false));
  }, []);

  return (
    <nav className="ab-nav" aria-label="Site navigation">
      <div className="ab-nav-inner">
        <Link to="/about" className="ab-nav-brand">
          <img className="ab-nav-logo" src="/logo_sq.png" alt="Catty logo" />
          <span className="ab-nav-brand-name">Catty <span>by JoinedUpData</span></span>
        </Link>
        <Link
          to={isAuthed ? '/' : '/login'}
          className="ab-btn ab-btn-primary"
          style={{ opacity: isAuthed === null ? 0 : 1, transition: 'opacity 0.3s ease', pointerEvents: isAuthed === null ? 'none' : undefined }}
        >
          {isAuthed ? 'Dashboard' : 'Sign in'}
        </Link>
      </div>
    </nav>
  );
}
